import { render, staticRenderFns } from "./PhraseWithUserText.vue?vue&type=template&id=643f536c&scoped=true&"
import script from "./PhraseWithUserText.vue?vue&type=script&lang=js&"
export * from "./PhraseWithUserText.vue?vue&type=script&lang=js&"
import style0 from "./PhraseWithUserText.vue?vue&type=style&index=0&id=643f536c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f536c",
  null
  
)

export default component.exports